import horsiaLogo from "../../assets/horsia-logo.webp";
import atLogo from "../assets/AT-Logo_Web.png";

/**
 * Info-Ansicht für Besucher die NICHT den KVA sehen sollen.
 *
 * Wichtige Eigenschaften (siehe Geo-Gating-Prompt):
 * - Wirkt wie eine absichtlich gestaltete Übersichts-/Kontakt-Seite,
 *   NICHT wie eine Sperre. Keine "Diese Seite ist nicht verfügbar"-Texte.
 * - Enthält KEINE Preisdaten im DOM (nicht versteckt, nicht in Kommentaren) —
 *   Wettbewerber dürfen Preise nicht aus dem Source Code scrapen.
 * - Bietet einen dezenten Weg zum KVA für echte Kunden via Override-Param
 *   (?region=de) — Wording bewusst neutral, gibt nicht preis dass eine
 *   Länder-Erkennung läuft.
 */
export function InfoView() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-slate-700 font-normal">
      <header className="border-b border-neutral-100">
        <div className="max-w-5xl mx-auto px-4 py-6 flex items-end gap-5">
          <img src={horsiaLogo} alt="Horsia Logo" className="h-12 max-md:h-9 w-auto object-contain" />
          <img src={atLogo} alt="Animal Tree Logo" className="h-12 max-md:h-9 w-auto object-contain" />
        </div>
      </header>

      <main className="flex-1 max-w-3xl mx-auto px-4 py-12 lg:py-20">
        <h1 className="text-3xl lg:text-4xl font-medium mb-6">Horsia Pferdebestattung</h1>

        <p className="text-lg leading-relaxed mb-6">
          Wir begleiten Pferdehalter durch die letzte Reise ihres Vierbeiners — mit Würde,
          Erfahrung und dem nötigen Feingefühl. Von der Abholung am Stall bis zur Rückführung
          der Asche kümmern wir uns um alles.
        </p>

        <p className="text-lg leading-relaxed mb-12">
          Jede Bestattung ist individuell. Sprich uns an, damit wir gemeinsam einen passenden
          Ablauf für dich und dein Pferd planen können.
        </p>

        <div className="bg-neutral-50 rounded-xl p-6 lg:p-8 mb-10">
          <h2 className="text-xl font-medium mb-4">Kontakt</h2>
          <p className="mb-2">
            Telefon:{" "}
            <a className="underline" href="tel:+498007746838">
              0800 774 68 38
            </a>
          </p>
          <p>
            E-Mail:{" "}
            <a className="underline" href="mailto:kontakt@horsia.de">
              kontakt@horsia.de
            </a>
          </p>
        </div>

      </main>

      <footer className="border-t border-neutral-100 py-6 mt-auto">
        <div className="max-w-5xl mx-auto px-4 text-sm text-neutral-500 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div>Horsia Pferdebestattung · Eine Marke der Animal Tree</div>
          <nav className="flex flex-wrap gap-x-5 gap-y-2">
            <a className="hover:underline" href="https://animaltree.de/datenschutz/" target="_blank" rel="noreferrer">
              Datenschutz
            </a>
            <a className="hover:underline" href="https://animaltree.de/agb/" target="_blank" rel="noreferrer">
              AGB
            </a>
            <a className="hover:underline" href="https://animaltree.de/impressum/" target="_blank" rel="noreferrer">
              Impressum
            </a>
          </nav>
        </div>
      </footer>
    </div>
  );
}
